import { render, staticRenderFns } from "./notificationChild.vue?vue&type=template&id=7e6a75a3&scoped=true"
import script from "./notificationChild.vue?vue&type=script&lang=js"
export * from "./notificationChild.vue?vue&type=script&lang=js"
import style0 from "./notificationChild.vue?vue&type=style&index=0&id=7e6a75a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6a75a3",
  null
  
)

export default component.exports